import React, { useRef, useEffect } from "react";
import Printer from '../../images/printer.svg';
import { GetProgress, PrintJobId } from "../../service/ServiceJob";
import { v4 as uuidv4 } from 'uuid';

export function Jobs({ styles, listJobs, isOpen, setIsOpen, jobSelecionado, selecionarJob, setIsLoading, setMsgLoading }) {

    const jobContainerRef = useRef();
    const isMobile = window.mobilecheck();

    useEffect(() => {
        if (jobSelecionado) {
            const jobElement = document.getElementById(`job-${jobSelecionado.Id}`);
            if (jobElement) {
                jobElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }
    }, [jobSelecionado]);

    async function printJobId(JobId) {
        setIsLoading(true);
        setMsgLoading('Gerando PDF');

        let intervalo;
        try {
            intervalo = setInterval(async () => {
                try {
                    const progress = await GetProgress(JobId);
                    if (progress.data.progress === 100) {
                        setMsgLoading(`Finalizando...`);
                    }
                } catch (error) {
                    console.error('Erro ao buscar progresso', error);
                }
            }, 3000);

            const response = await PrintJobId(JobId);

            if (isMobile) {
                const nameFile = uuidv4();
                const file = new File([response.data], nameFile, { type: "application/pdf" });
                const pdfUrl = URL.createObjectURL(file);
                var fileLink = document.createElement('a');
                fileLink.href = pdfUrl;
                fileLink.download = nameFile;
                fileLink.click();
                setIsLoading(false);
            } else {
                const blob = new Blob([response.data], { type: 'application/pdf' });
                const pdfUrl = URL.createObjectURL(blob);
                window.open(pdfUrl);
                setIsLoading(false);
            }
        } catch (error) {
            setIsLoading(false);
            setMsgLoading('Carregando imagens...');
            console.error('Erro ao imprimir job', error);
        } finally {
            setMsgLoading('Carregando imagens...');
            clearInterval(intervalo);
            setIsLoading(false);
        }
    }

    return (
        <div className={`${styles.list} ${isOpen && styles.open}`} ref={jobContainerRef}>
            {listJobs.map((job, index) => (
                <div key={index} id={`job-${job.Id}`} className={`${styles['series-container']} ${job.Id === jobSelecionado.Id ? styles.boxSelected : ''}`}>
                    <div className={styles.miniature} onClick={() => { selecionarJob(job); isMobile && setIsOpen(false) }}>
                        {job.Minuature
                            ? <img src={`data:image/png;base64, ${job.Minuature}`} />
                            : <div className={styles.miniaturePlaceholder} />
                        }
                    </div>
                    <button
                        title="Imprimir"
                        className={styles.print}
                        style={{ width: '100%', borderRadius: '0px 0px 11px 11px' }}
                        onClick={() => printJobId(job.Id)}
                    >
                        <img src={Printer} width={24} /> Imprimir
                    </button>
                </div>
            ))
            }
        </div>
    );
}